(function () {
  var MAX_AGE = 30 * 24 * 60 * 60;
  var SINCE = "gh_attr_since";
  var NOTICE = "26.10.2026";
  var clickAt = (function () {
    var q = new URLSearchParams(window.location.search);
    if (q.has("utm_link_type") || q.has("utm_custom_link_id") || q.has("discount")) {
      return Math.floor(Date.now() / 1000);
    }
    return 0;
  })();
  var pendingSuperfiliate = "";
  var superfiliateLoaded = false;
  var apiReady = false;

  function privacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function marketingAllowed() {
    try {
      var cp = privacy();
      if (!cp || typeof cp.marketingAllowed !== "function") return false;
      return cp.marketingAllowed() === true;
    } catch (e) {
      return false;
    }
  }

  function cookieDesc() {
    return (
      Object.getOwnPropertyDescriptor(Document.prototype, "cookie") ||
      Object.getOwnPropertyDescriptor(HTMLDocument.prototype, "cookie")
    );
  }

  var desc = cookieDesc();

  function readCookieJar() {
    return desc && desc.get ? desc.get.call(document) : document.cookie;
  }

  function writeRaw(value) {
    if (desc && desc.set) desc.set.call(document, value);
  }

  function cookieValue(name) {
    var match = (" " + readCookieJar() + ";").match(new RegExp(" " + name + "=([^;]*);"));
    return match ? decodeURIComponent(match[1]) : "";
  }

  function affiliateName(name) {
    return /^(sf[-_]|superfiliate|emid$|sf_meta_|_up_|__up)/i.test(name);
  }

  function affiliateStorageKey(key) {
    return /_up_|trackedSourceId|trackedCompleteOrderSourceId|^emid$/i.test(key);
  }

  function sinceStamp() {
    var raw = cookieValue(SINCE);
    var n = parseInt(raw, 10);
    return n > 0 ? n : 0;
  }

  function writeSince(stamp) {
    writeRaw(SINCE + "=" + stamp + "; path=/; max-age=" + MAX_AGE + "; SameSite=Lax");
  }

  function remaining() {
    var origin = sinceStamp();
    if (clickAt && (!origin || clickAt > origin)) {
      writeSince(clickAt);
      origin = clickAt;
    }
    if (!origin) return 0;
    return Math.max(0, origin + MAX_AGE - Math.floor(Date.now() / 1000));
  }

  function rewriteCookie(value) {
    var text = String(value || "");
    var name = text.split("=")[0].trim();
    if (!affiliateName(name)) return text;
    var deleting = /max-age=0/i.test(text) || /expires=thu, 01 jan 1970/i.test(text);
    if (deleting) return text;
    if (!marketingAllowed()) return name + "=; path=/; max-age=0; SameSite=Lax";
    var left = remaining();
    if (left <= 0) return name + "=; path=/; max-age=0; SameSite=Lax";
    if (/max-age=\d+/i.test(text)) {
      return text.replace(/max-age=\d+/i, function (part) {
        var asked = parseInt(part.split("=")[1], 10);
        return "max-age=" + Math.min(asked, left);
      });
    }
    return text + "; max-age=" + left;
  }

  try {
    var origSetItem = window.localStorage.setItem.bind(window.localStorage);
    window.localStorage.setItem = function (key, value) {
      if (affiliateStorageKey(key) && !marketingAllowed()) return;
      return origSetItem(key, value);
    };
  } catch (e) {}

  if (desc && desc.configurable && desc.set && desc.get) {
    Object.defineProperty(Document.prototype, "cookie", {
      configurable: true,
      enumerable: desc.enumerable,
      get: function () {
        return desc.get.call(this);
      },
      set: function (value) {
        desc.set.call(this, rewriteCookie(value));
      },
    });
  }

  function hostBlocked(url) {
    var s = String(url || "");
    if (/linkster\.co|uppromote/i.test(s)) return true;
    if (/superfiliate-cdn\.com|app\.superfiliate\.com/i.test(s)) return !marketingAllowed();
    return false;
  }

  function rememberSuperfiliate(url) {
    if (/superfiliate-cdn\.com\/storefront\.js/i.test(url)) pendingSuperfiliate = url;
  }

  var origCreate = document.createElement;
  document.createElement = function (name) {
    var el = origCreate.apply(document, arguments);
    if (String(name).toLowerCase() !== "script") return el;
    var proto = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, "src");
    var origSetAttribute = el.setAttribute;
    function accept(url) {
      if (hostBlocked(url)) {
        rememberSuperfiliate(url);
        return false;
      }
      return true;
    }
    el.setAttribute = function (attr, value) {
      if (String(attr).toLowerCase() === "src" && !accept(value)) return;
      return origSetAttribute.apply(this, arguments);
    };
    if (proto && proto.set && proto.get) {
      Object.defineProperty(el, "src", {
        configurable: true,
        get: function () {
          return proto.get.call(this);
        },
        set: function (value) {
          if (!accept(value)) return;
          proto.set.call(this, value);
        },
      });
    }
    return el;
  };

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === "string" ? input : input && input.url;
      if (hostBlocked(url)) return Promise.resolve(new Response(null, { status: 204 }));
      return origFetch.apply(this, arguments);
    };
  }

  if (navigator.sendBeacon) {
    var origBeacon = navigator.sendBeacon.bind(navigator);
    navigator.sendBeacon = function (url, data) {
      if (hostBlocked(url)) return true;
      return origBeacon(url, data);
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ghBlock = hostBlocked(url);
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__ghBlock) return;
    return origSend.apply(this, arguments);
  };

  function expire(name) {
    var host = window.location.hostname.replace(/^www\./, "");
    writeRaw(name + "=; path=/; max-age=0; SameSite=Lax");
    writeRaw(name + "=; path=/; max-age=0; domain=" + window.location.hostname);
    writeRaw(name + "=; path=/; max-age=0; domain=." + host);
  }

  function clearAffiliateStorage() {
    readCookieJar()
      .split(";")
      .forEach(function (part) {
        var name = part.split("=")[0].trim();
        if (affiliateName(name) || name === SINCE) expire(name);
      });
    try {
      var drop = [];
      for (var i = 0; i < window.localStorage.length; i++) {
        var key = window.localStorage.key(i);
        if (affiliateStorageKey(key)) drop.push(key);
      }
      drop.forEach(function (key) {
        window.localStorage.removeItem(key);
      });
    } catch (e) {}
    document.querySelectorAll("script[src]").forEach(function (node) {
      if (hostBlocked(node.src) || /superfiliate|linkster|uppromote/i.test(node.src)) node.remove();
    });
  }

  function clearCartAttributes() {
    fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "sf-code": "",
          "sf-attributed-at": "",
          "sf-sourced-from-google": "",
          __linksterEmid: "",
        },
      }),
    }).catch(function () {});
  }

  function loadSuperfiliate() {
    if (!marketingAllowed() || superfiliateLoaded) return;
    var url = pendingSuperfiliate || "https://superfiliate-cdn.com/storefront.js?shop=s0j3v0-mk.myshopify.com";
    if (document.querySelector('script[src*="superfiliate-cdn.com/storefront.js"]')) {
      superfiliateLoaded = true;
      return;
    }
    superfiliateLoaded = true;
    var script = origCreate.call(document, "script");
    script.async = true;
    script.src = url;
    document.head.appendChild(script);
  }

  function recordConsent() {
    var cp = privacy();
    if (!cp || typeof cp.currentVisitorConsent !== "function") return;
    var consent = cp.currentVisitorConsent() || {};
    if (!consent.marketing && !consent.analytics && !consent.preferences) return;
    var entry = {
      t: new Date().toISOString(),
      marketing: consent.marketing || "",
      analytics: consent.analytics || "",
      preferences: consent.preferences || "",
      notice: NOTICE,
    };
    try {
      var log = JSON.parse(window.localStorage.getItem("gh_consent_log") || "[]");
      if (!Array.isArray(log)) log = [];
      var last = log[log.length - 1];
      if (!last || last.marketing !== entry.marketing || last.analytics !== entry.analytics || last.preferences !== entry.preferences) {
        log.push(entry);
        window.localStorage.setItem("gh_consent_log", JSON.stringify(log.slice(-20)));
      }
    } catch (e) {}
  }

  function decorateBanner() {
    var banner = document.getElementById("shopify-pc__banner");
    if (!banner || banner.querySelector(".gh-cookie-vendors")) return;
    var note = document.createElement("div");
    note.className = "gh-cookie-vendors";
    note.style.cssText = "margin:12px 16px 4px;font-size:13px;line-height:1.45;";
    note.innerHTML =
      "<p><strong>Marketing</strong> attributes an affiliate link to a later order through Superfiliate. Identifiers: sf-code, sf-attributed-at and Superfiliate cookies. Lifetime: 30 days from the link click. A later visit does not extend it. A creator code entered at purchase takes priority.</p><p>Linkster and UpPromote are not used. Cart and login cookies stay if you decline.</p>";
    banner.appendChild(note);
  }

  function onConsent() {
    var cp = privacy();
    if (!cp || typeof cp.marketingAllowed !== "function") return;
    apiReady = true;
    recordConsent();
    decorateBanner();
    if (marketingAllowed()) {
      loadSuperfiliate();
      return;
    }
    pendingSuperfiliate = "";
    superfiliateLoaded = false;
    clearAffiliateStorage();
    clearCartAttributes();
  }

  new MutationObserver(function () {
    decorateBanner();
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("visitorConsentCollected", onConsent);
  var featuresRequested = false;
  var tries = 0;
  var timer = window.setInterval(function () {
    tries += 1;
    if (privacy() && typeof privacy().marketingAllowed === "function") {
      window.clearInterval(timer);
      onConsent();
      return;
    }
    if (!featuresRequested && window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      featuresRequested = true;
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {
        window.clearInterval(timer);
        onConsent();
      });
    } else if (tries > 80) {
      window.clearInterval(timer);
    }
  }, 100);
})();
